import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {WRTCProviderService} from '@app/modules/wrtc/services/providers/wrtc-provider';
import {AccessType, ConnectionStatus, LogLevel, LogResource} from '@app/modules/shared/data/constants';
import {LogService} from '@app/services/log.service';
import {ClassroomAction, ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {CommandService} from '@app/services/command.service';
import {
  MediaDeviceConfigurationComponent
} from '@app/modules/shared/components/dialogs/media-device-configuration/media-device-configuration.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalUser, LocalUserAction, LocalUserState} from '@app/state/local-user.state';
import {CoreService} from '@app/services/core.service';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {
  ChangeTeacherNicknameComponent
} from "@app/modules/shared/components/dialogs/change-teacher-nickname/change-teacher-nickname.component";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap/modal/modal-ref";

@Component({
  selector: 'app-teachers-video-section',
  templateUrl: './teachers-video-section.component.html'
})
export class TeachersVideoSectionComponent implements OnInit, AfterViewInit {
  @ViewChild('mediaWrapper') set wrapper(wrapper: ElementRef<HTMLElement>) {
    if (wrapper) {
      this.wrtcProviderService.setCurrentUserMediaWrapper(wrapper.nativeElement);
    }
  }

  public localUser: LocalUser;
  // @Input() privateTalkInfo;
  public _remoteTeachers: RemoteParticipantInfo[];

  @Input()
  public set remoteTeachers(remoteTeachers: RemoteParticipantInfo[]) {
    this._remoteTeachers = remoteTeachers.sort((a, b) => {
      return a.additionalInfo.connectionTimestamp - b.additionalInfo.connectionTimestamp;   // sort by increasing
    });
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public AccessType = AccessType;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public ConnectionStatus = ConnectionStatus;

  public isLocalUserConnected = true;
  public isTeachersVideoMuted = false;
  public isTeachersAudioMuted = false;
  public isCurrentUserOnline = true;

  public classroom: ClassroomStateModel;

  constructor(
    private wrtcProviderService: WRTCProviderService,
    private store: Store,
    private commandService: CommandService,
    private coreService: CoreService,
    private wrtcService: WrtcService,
    private dialogService: NgbModal
  ) {}

  public ngOnInit(): void {
    this.registerStoreChangeListeners();
  }

  public registerStoreChangeListeners(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  public ngAfterViewInit(): void {
    LogService.writeLog(`teachers video section component is loaded`, LogLevel.DEBUG, LogResource.CORE);
  }

  public raiseHand(): void {
    if (this.localUser.isHandRaised) {
      this.coreService.sendCancelRaiseHand().subscribe(() => {
        this.store.dispatch(new LocalUserAction.SetLocalUserRaiseHand(false));
      });
    } else {
      this.coreService.sendRaiseHand().subscribe(() => {
        this.store.dispatch(new LocalUserAction.SetLocalUserRaiseHand(true));
      });
    }
  }

  public openAudioVideoDeviceConfigurationDialog(): void {
    this.dialogService.open(MediaDeviceConfigurationComponent);
  }

  public changeTeacherNickName(): void {
    const dialog: NgbModalRef = this.dialogService.open(ChangeTeacherNicknameComponent,
        {size: 'md'});

    dialog.componentInstance.nickname = this.localUser.nickname;

    dialog.result.then((nickname) => {
      if (nickname !== null && nickname !== undefined) {
        this.coreService.sendTeacherNickname(nickname).subscribe();
      }
    }, (reason) => {
      console.log('dialog closed ' + reason);
    });
  }

  public toggleShowChat(): void {
    this.store.dispatch(new ClassroomAction.ToggleIsChatHidden(!this.classroom.isChatHidden));
  }

  public toggleMuteTeachersVideo(): void {
    const doMute = !this.localUser.video.isMuted;
    this.store.dispatch(new LocalUserAction.SetIsVideoMuteState(doMute));
    this.wrtcProviderService.toggleDisableSelfVideo(doMute);
    if (doMute) {
      this.wrtcService.sendVideoMute(this.localUser.id).subscribe();
    } else {
      this.wrtcService.sendVideoUnmute(this.localUser.id).subscribe();
    }
  }

  public toggleMuteTeachersAudio(): void {
    const doMute = !this.localUser.audio.isMuted;
    this.store.dispatch(new LocalUserAction.SetIsAudioMuteState(doMute));
    this.wrtcProviderService.toggleDisableSelfAudio(doMute);
    if (doMute) {
      this.wrtcService.sendAudioMute(this.localUser.id).subscribe();
    } else {
      this.wrtcService.sendAudioUnmute(this.localUser.id).subscribe();
    }
  }

  public handleClassroomUnmuteButtonClick(): void {
    this.store.dispatch(new ClassroomAction.ToggleRoomMutedBecauseOfBlockedMicAnCam(false));
    this.wrtcService.dropRoomMuteBecauseOfBlockedMicAndCam();
  }

  public expelTeacher(teacherId: number): void {
    this.coreService.sendExpelStaff(teacherId).subscribe();
  }
}
